export function Map() {
  return (
    <div
      style={{
        height: 300,
        width: '100%',
        borderRadius: 16,
        overflow: 'hidden',
        background: 'var(--gray-200)'
      }}>
      <svg
        role="img"
        aria-label="Map with directions to Harborlight Coffee"
        width="100%"
        height="100%"
        viewBox="0 0 736 300"
        preserveAspectRatio="xMidYMid slice"
        style={{display: 'block'}}>
        <g transform="rotate(-5 368 150) translate(108 13)">
          <g fill="oklch(var(--lightness-300) 0.08 145)">
            <rect x="68" y="38" width="84" height="64" rx="6" />
            <rect x="468" y="38" width="84" height="64" rx="6" />
          </g>
          <path
            d="M68 74 Q 110 52 152 82M468 60 Q 510 90 552 70"
            fill="none"
            stroke="oklch(calc(var(--lightness-200) + 8%) 0 0)"
            strokeWidth="2"
          />
          <g fill="var(--gray-300)">
            <rect x="-128" y="-40" width="76" height="60" rx="2" />
            <rect x="-28" y="-40" width="76" height="60" rx="2" />
            <rect x="72" y="-40" width="76" height="60" rx="2" />
            <rect x="172" y="-40" width="76" height="60" rx="2" />
            <rect x="272" y="-40" width="76" height="60" rx="2" />
            <rect x="372" y="-40" width="76" height="60" rx="2" />
            <rect x="472" y="-40" width="76" height="60" rx="2" />
            <rect x="572" y="-40" width="76" height="60" rx="2" />
            <rect x="-128" y="42" width="34" height="56" rx="2" />
            <rect x="-88" y="42" width="36" height="24" rx="2" />
            <rect x="-88" y="72" width="36" height="26" rx="2" />
            <rect x="-28" y="42" width="76" height="56" rx="2" />
            <rect x="172" y="42" width="36" height="56" rx="2" />
            <rect x="214" y="42" width="34" height="24" rx="2" />
            <rect x="214" y="72" width="34" height="26" rx="2" />
            <rect x="272" y="42" width="76" height="24" rx="2" />
            <rect x="272" y="72" width="30" height="26" rx="2" />
            <rect x="308" y="72" width="40" height="26" rx="2" />
            <rect x="372" y="42" width="40" height="56" rx="2" />
            <rect x="418" y="42" width="30" height="56" rx="2" />
            <rect x="572" y="42" width="76" height="56" rx="2" />
            <rect x="-128" y="122" width="76" height="24" rx="2" />
            <rect x="-128" y="152" width="36" height="26" rx="2" />
            <rect x="-86" y="152" width="34" height="26" rx="2" />
            <rect x="-28" y="122" width="76" height="56" rx="2" />
            <rect x="72" y="122" width="40" height="56" rx="2" />
            <rect x="118" y="122" width="30" height="24" rx="2" />
            <rect x="172" y="122" width="76" height="24" rx="2" />
            <rect x="172" y="152" width="36" height="26" rx="2" />
            <rect x="272" y="122" width="34" height="56" rx="2" />
            <rect x="312" y="122" width="36" height="56" rx="2" />
            <rect x="372" y="122" width="40" height="56" rx="2" />
            <rect x="418" y="122" width="30" height="56" rx="2" />
            <rect x="472" y="122" width="34" height="56" rx="2" />
            <rect x="512" y="122" width="36" height="24" rx="2" />
            <rect x="512" y="152" width="36" height="26" rx="2" />
            <rect x="572" y="122" width="76" height="56" rx="2" />
          </g>
          <path
            d="M-300 30H700M-300 110H700M-300 190H700M-140 -100V400M-40 -100V400M60 -100V400M160 -100V400M260 -100V400M360 -100V400M460 -100V400M560 -100V400M660 -100V400"
            stroke="oklch(calc(var(--lightness-200) + 8%) 0 0)"
            strokeWidth="8"
          />
          <path d="M-300 215H700" stroke="var(--gray-400)" strokeWidth="15" />
          <path d="M-300 215H700" stroke="oklch(var(--lightness-400) 0.1 85)" strokeWidth="12" />
          <path
            d="M-300 244 C -150 236, 0 256, 120 250 S 300 238, 420 246 S 600 236, 700 244 V 420 H -300 Z"
            fill="oklch(var(--lightness-400) 0.07 235)"
          />
          <g
            fontSize="8"
            fontWeight="600"
            fill="var(--gray-1000)"
            stroke="oklch(calc(var(--lightness-200) + 8%) 0 0)"
            strokeWidth="3"
            paintOrder="stroke"
            textAnchor="middle">
            <text dominantBaseline="central" transform="translate(-40 78) rotate(-90)">
              Cedar St
            </text>
            <text dominantBaseline="central" transform="translate(160 78) rotate(-90)">
              Main St
            </text>
            <text dominantBaseline="central" transform="translate(260 78) rotate(-90)">
              Harbor St
            </text>
            <text dominantBaseline="central" transform="translate(360 78) rotate(-90)">
              Maple St
            </text>
            <text dominantBaseline="central" x="510" y="30">
              5th St
            </text>
            <text dominantBaseline="central" x="210" y="30">
              5th St
            </text>
            <text dominantBaseline="central" x="10" y="110">
              4th St
            </text>
            <text dominantBaseline="central" x="310" y="110">
              4th St
            </text>
            <text dominantBaseline="central" x="110" y="190">
              3rd St
            </text>
            <text dominantBaseline="central" x="510" y="190">
              3rd St
            </text>
            <text
              dominantBaseline="central"
              x="-60"
              y="215"
              stroke="oklch(var(--lightness-400) 0.1 85)">
              Route 9
            </text>
            <text
              dominantBaseline="central"
              x="410"
              y="215"
              stroke="oklch(var(--lightness-400) 0.1 85)">
              Route 9
            </text>
          </g>
          <text
            x="460"
            y="272"
            fontSize="9"
            fontStyle="italic"
            fontWeight="500"
            fill="oklch(var(--lightness-1000) 0.1 235)"
            textAnchor="middle">
            Marlow Bay
          </text>
          <g transform="translate(260 150) rotate(5)">
            <ellipse cx="0" cy="0" rx="6" ry="2" fill="rgb(0 0 0 / 0.25)" />
            <path
              d="M0 0 C -4 -10, -14 -16, -14 -26 A 14 14 0 1 1 14 -26 C 14 -16, 4 -10, 0 0 Z"
              fill="oklch(0.63 0.21 27)"
              stroke="#fff"
              strokeWidth="1.5"
            />
            <circle cx="0" cy="-26" r="5.5" fill="#fff" />
          </g>
        </g>
      </svg>
    </div>
  );
}
